import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

export const LoadingSymbolColor = "#10206C";

/** This is a base class for all main page components that are included in the root router */
@Component
export class BaseRootPageComponent extends Vue {
  /**
   * Used to set the title in the navbar. This must be explicitly called by each root view component (the ones
   * referenced by the router)
   */
  @Prop(Function) readonly setTitle!: (title?: string | null) => void;

  created() {
    // Default to setting the title to the route's name
    this.setTitle(this.$route.name);
  }

  get loadingSymbolColor() {
    return LoadingSymbolColor;
  }
}
